// extracted by mini-css-extract-plugin
export default {"Choose_btn__container":"ChooserDegrees_Choose_btn__container__UORWD","Choose_btn":"ChooserDegrees_Choose_btn__+D+67","active":"ChooserDegrees_active__LLLgg"};